import { useMemo } from "react";
import { Page } from "@/components/layout";
import { useAuth } from "@/hooks/useAuth";
import { MentorChatPanels } from "@/components/pages/ai-mentor";
import { pickHubGreetingLine } from "@/lib/hubGreeting";
import { extractFirstName } from "@/lib/userName";

export const ChatHubPage = () => {
  const { userData } = useAuth();

  const firstName = extractFirstName(userData) ?? "there";

  const greetingLine = useMemo(
    () => pickHubGreetingLine({ firstName, userId: userData?.user_id }),
    [firstName, userData?.user_id]
  );

  return (
    <Page.Container key="hub-home">
      {/* Header left blank on purpose: the hub hero below owns the greeting so the layout reads as a Claude-style "New Chat" canvas. */}
      <Page.Header className="md:py-2" />

      <Page.Content className="min-h-0 flex-1 gap-0 space-y-0">
        <MentorChatPanels chatEntry="ai_mentor" hubLayout hubHero hubGreetingLine={greetingLine} />
      </Page.Content>
    </Page.Container>
  );
};
